import {
    AppBar,
    Button,
    IconButton,
    SwipeableDrawer,
    Toolbar,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import React, { useContext, useState } from "react";
import { useHistory, useLocation } from "react-router";
import Sidebar from "ui/componentes/Sidebar/Sidebar";
import { LoggedUserContext } from "../LoggedUserContext";

const onClose = (setVisible) => () => setVisible(false);

const Header = () => {
    const loggedUser = useContext(LoggedUserContext);
    const [visible, setVisible] = useState(false);
    const history = useHistory();
    if (useLocation().pathname === "/auth/resetMethods") {
        return null;
    }
    return (
        <>
            <AppBar position="relative" elevation={0}>
                <Toolbar>
                    {loggedUser.id ? (
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => setVisible(!visible)}
                        >
                            <MenuIcon />
                        </IconButton>
                    ) : (
                        <Button
                            color="inherit"
                            variant="text"
                            onClick={() => history.push("/sign-in")}
                        >
                            Login
                        </Button>
                    )}
                    <div style={{ flexGrow: 1 }} />
                    <img
                        src={`${process.env.PUBLIC_URL}/img/irb_logo_white.png`}
                        style={{ maxHeight: 50 }}
                        alt="logo_irb"
                    />
                </Toolbar>
            </AppBar>
            {loggedUser.id && (
                <SwipeableDrawer
                    open={visible}
                    onClose={() => setVisible(false)}
                    onOpen={() => false}
                >
                    <Sidebar open={visible} onClose={onClose(setVisible)} />
                </SwipeableDrawer>
            )}
        </>
    );
};

export { Header };
